import { QueryFactory } from '@lmt/shared-types';
import { getFromCacheOrRequest } from '@lmt/unicorn-shared/app/api/custom-hooks';
import { QueryClient } from '@tanstack/react-query';

export async function getDataBlockTypes(queryClient: QueryClient) {
  const result = await getFromCacheOrRequest(
    queryClient,
    QueryFactory.DataBlockTypeQuery.getQueryKey(),
    () => QueryFactory.DataBlockTypeClient.get(),
  );
  return result.filter((x) => !x.isDeactivated && !x.isDeleted);
}
export async function getMergeFields(queryClient: QueryClient) {
  return await getFromCacheOrRequest(
    queryClient,
    QueryFactory.MergeFieldQuery.getQueryKey(),
    () => QueryFactory.MergeFieldClient.get(),
  );
}
export async function getDataBlockDictionaries(queryClient: QueryClient) {
  return await getFromCacheOrRequest(
    queryClient,
    QueryFactory.DataBlockDictionaryQuery.getQueryKey(),
    () => QueryFactory.DataBlockDictionaryClient.get(),
  );
}
